/** @format */

import styled, { css } from 'styled-components';
import config from 'config.json';
import theme from 'theme';
import { DropdownProps } from './Dropdown.types';

const StyledDropdown = styled.select<DropdownProps>`
  && {
    width: 100%;
    line-height: 3rem;
    margin-top: 0.3em;
    margin-bottom: 0.5em;
    padding: 0 1rem;
    background-color: ${theme.lightBackgroundColor};
    border: 1px solid #d8d8d8;
    font-size: 1rem;
    transition: all 0.3s ease-in-out;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    border-radius: 2px;
    display: inline-block;
    box-sizing: border-box;
    height: 3rem;

    ${
      config.theme === 'addsecure' &&
      css`
        &&& {
          box-shadow: none;
          border-radius: 5px;
          border-color: #aaa;
          background-color: white;
        }
      `
    }

    &::placeholder {
      position: relative;
      top: -2px;
      white-space: pre-line;
    }

    &:focus {
      border-color: rgba(82, 168, 236, 0.8);
      outline: none;
      box-shadow:
        inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(82, 168, 236, 0.6);
      ${
        config.theme === 'addsecure' &&
        css`
          &&& {
            box-shadow: none;
            border-color: mix(white, $ewm-turquoise, 30%);
          }
        `
      }

    &:read-only {
      -webkit-user-select: all;
      -moz-user-select: all;
      -ms-user-select: all;
      user-select: all;
    }
  }
  

  ${({ disabled }) =>
    disabled &&
    css`
      &&& {
        background-color: rgb(245, 245, 245) !important;
        color: rgb(136, 136, 136) !important;
        border: 1px solid rgb(136, 136, 136) !important;
        cursor: not-allowed;
      }
    `}

  ${({ readOnly }) =>
    readOnly &&
    css`
      &&& {
        background-color: rgb(245, 245, 245) !important;
        color: rgb(136, 136, 136) !important;
        border: 1px solid rgb(136, 136, 136) !important;
        cursor: not-allowed;
      }
    `}
`;

const Icon = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
`;

const Dropdown = (props: DropdownProps) => {
  return (
    <>
      {props.label ? <label>{props.label}</label> : null}
      <div className='select-wrapper'>
        <StyledDropdown
          readOnly={props.readOnly}
          disabled={props.disabled}
          options={props.options}
          onChange={props.onChange}
          value={props.value}
          name={props.name}
        >
          {props.options
            ? props.options.map((option) => {
                return (
                  <option key={option} value={option}>
                    {option}
                  </option>
                );
              })
            : props.children}
        </StyledDropdown>
        {props.readOnly || props.disabled ? (
          <Icon>
            <i
              className='fa-solid fa-lock fa-lg'
              style={{ color: theme.darkGrey }}
            ></i>
          </Icon>
        ) : null}
      </div>
    </>
  );
};

export default Dropdown;
